<template>
  <div class="set-select">
    <div class="input-warp">
      <div class="label-title">{{ label }}：</div>
      <el-select clearable @change="inputValueChange" :value="value" placeholder="请选择">
        <el-option v-for="item in range" :key="item" :label="item" :value="item" />
      </el-select>
      <div class="suffix-words">
        {{ suffix }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SetSelect',
  components: {},
  props: {
    label: {
      default: '召开前',
      type: String,
    },
    suffix: {
      default: '人',
      type: String,
    },
    placeholder: {
      default: '',
      type: String,
    },
    value: {
      default: '',
      //   type: String,
    },
    range: {
      default: 600,
    },
  },
  data() {
    return {
      inputValue: '',
    };
  },
  watch: {},
  mounted() {},
  created() {},
  methods: {
    /**
     *
     */
    inputValueChange(e) {
      this.$emit('input', e);
    },
  },
};
</script>
<style lang="scss" scoped>
.input-warp {
  display: flex;
  align-items: center;
  .label-title {
    width: 80px;
    white-space: nowrap;
  }
}
.suffix-words {
  padding-left: 10px;
}
</style>
